/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Timezoneid2Inputs */

const en_entity_timezoneid2 = /** @type {(inputs: Entity_Timezoneid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Zone ID`)
};

const de_entity_timezoneid2 = /** @type {(inputs: Entity_Timezoneid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitzonen-ID`)
};

/**
* | output |
* | --- |
* | "Time Zone ID" |
*
* @param {Entity_Timezoneid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_timezoneid2 = /** @type {((inputs?: Entity_Timezoneid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Timezoneid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_timezoneid2(inputs)
	return de_entity_timezoneid2(inputs)
});
export { entity_timezoneid2 as "entity_timeZoneId" }